<template>
  <div class="container-fluid mt" id="vue-app">
    <double-bounce v-if="loading"></double-bounce>
      <div class="top" v-if="!loading">
        <div>
            <h2>{{ userData.first_name }} {{ userData.last_name }}</h2>
            <router-link to="/available-properties/update/" class="logout uppercase"><i class="fas fa-edit"></i>Edit Account</router-link>
        </div>
        <button class="logout uppercase" v-on:click="logout"><i class="fas fa-user-alt"></i>Logout</button>
      </div>
    <div class="table" v-if="!loading">
        <table>
            <tr>
                <th>Application ID</th>
                <th>Parcel Number</th>
                <th>Application Status</th>
                <th>Application Type</th>
                <th>Application Lead</th>
            </tr>
            <tr v-for="app in applications" v-bind:key="app.application_id">
                <td>{{ app.application_id }}</td>
                <td>{{ app.app_parcel}}</td>
                <td>{{ app.application_status }}</td>
                <td>{{ app.disp_app_type}}</td>
                <td>{{ app.app_lead }}</td>
            </tr>
        </table>

    </div>

  </div>
</template>

<script>
import axios from 'axios';
import {DoubleBounce} from 'vue-loading-spinner';


export default {
  name: 'ApplicationIndex',

  components: {
      DoubleBounce,
  },

  data() {
    return {
        loading: true,
        userData: {},
        applications: [],
    }
  },
  created() {
    // Get user information
    axios.post('/wp-json/HCLRC/v1/get-public-user-profile')
    .then(res => {
        if (res.data.data.message == 'INVALID USER') {
            this.$router.push({path: '/available-properties/login', query: {fromApplication: true, redirect: '/available-properties/applications/' + this.$route.params.property_id }});

        }
        this.$set(this, 'loading', false);
        this.$set(this, 'userData', res.data.data.data);

        
        
    })
    .catch(function (error) {
        // if an error occurs, print that error
        console.log(error);

    });

    // Get user's application list
    axios.post('/wp-json/HCLRC/v1/get-public-application-list')
    .then(res => {
        if (res.data.data.data) {

        }
        this.$set(this, 'applications', res.data.data.data)
        
    })
    .catch(function (error) {
        // if an error occurs, print that error
        console.log(error);

    });

  },
  methods: {
      logout() {
        this.$parent.logout();
      },
      update() {
          
      }
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">
.top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;

    a {
        font-weight: 700;
        color: #dc3b43;
    }
}
table {
    width: 100%;
}

button, a {
    cursor: pointer;
    &.logout {
        background: none;
        border: none;
        color: #276AA6;
        font-size: 1rem;
        font-family: 'din-2014';
        font-weight: 700;
        padding-right: 0;

        i {
            margin-right: .5rem;
        }

    }
}


</style>


// WEBPACK FOOTER //
// src/components/Application/ApplicationIndex.vue